export default __webpack_public_path__ + "static/media/aktyna.533b5612.jpg";